import { Skeleton } from '@progress/kendo-react-indicators';
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { Dropdown } from "react-bootstrap";
import PropTypes from "prop-types"; 

export const TaskListSkeleton = () => {
    return(
        <div className="static-list-container skeleton-tasklist-container task-skeleton-container-shadow">
        <Grid
          data={Array.from({ length: 10 }).map((_, idx) => ({ id: idx }))}
          pageable={{
            info: false,
          }}
        >
          <GridToolbar>
            <div className="task-grid-toolbar">
              <div className="toolbar-left">
                <Skeleton shape="rectangle" className='skeleton-searchbar-tasklist' animation={{ type: "wave" }} data-testid="skeleton-searchbar-tasklist"/>
                <Skeleton shape="rectangle" className='skeleton-button-tasklist' animation={{ type: "wave" }} data-testid="skeleton-button-tasklist"/>
              </div>
              <div className='toolbar-right'>
                <Skeleton shape="rectangle" className='skeleton-button-tasklist' animation={{ type: "wave" }} />
                <Skeleton shape="rectangle" className='skeleton-button-tasklist' animation={{ type: "wave" }} />
              </div>
            </div>
          </GridToolbar>
          <Column
            title=""
            width="50px"
            cell={(cellItem) => {
              const isFirstRow = cellItem.dataIndex === 0;
              return (
                <td className="skeleton-cell">
                  <Skeleton
                    shape="rectangle"
                    className='skeleton-icon-tasklist'
                    animation={isFirstRow ? { type: "wave" } : { type: "pulse" }}
                    data-testid="text-skeleton"
                  />
                </td>
              );
            }}
          />
          {Array.from({ length: 8 }).map((_, textIdx) => (
            <Column
              key={textIdx}
              title=""
              cell={(cellItem) => {
                const isFirstRow = cellItem.dataIndex === 0;
                return (
                  <td className="skeleton-cell" style={{border: "none"}}>
                    <Skeleton
                      shape="text"
                      className = "skeleton-text-tasklist"
                      animation={isFirstRow ? { type: "wave" } : { type: "pulse" }}
                    />
                  </td>
                );
              }}
            />
          ))}
        </Grid>
      </div>
    )
}

export const SkeletonItem = ({ squareSize, textWidth, marginBottom, marginTop }) => {
  const mbClass = marginBottom !== undefined ? `mb-${marginBottom}` : 'mb-3';
  const mtClass = marginTop !== undefined ? `mt-${marginTop}` : 'mt-0';

  return (
    <div className={`${mbClass} ${mtClass}`}>
      <span className="d-flex">
        <Skeleton
          shape="square"
          style={{ width: squareSize, height: squareSize, marginRight: "10px" }}
          data-testid="square-skeleton"
        />
        <Skeleton
          shape="text"
          style={{ width: textWidth, height: "14px" }}
        />
      </span>
    </div>
  );
};
  
  export const TaskActionSkeleton = () => {
    const skeletonItems = [
      { squareSize: "16px", textWidth: "90px", marginBottom: 4 },
      { squareSize: "16px", textWidth: "100px", marginBottom: 3 },
      "divider",
      { squareSize: "16px", textWidth: "100px", marginBottom: 4, marginTop: 3 },
      { squareSize: "16px", textWidth: "150px", marginBottom: 3 },
      "divider",
      { squareSize: "16px", textWidth: "120px", marginTop: 3 },
    ];
  
    return (
      <Dropdown.Item className="edit-dropdown-menu-item h-50">
        {skeletonItems.map((item, idx) =>
          item === "divider" ? (
            <Dropdown.Divider key={idx} role="separator" />
          ) : (
            <div key={idx} data-testid="skeleton-item">
              <SkeletonItem
                squareSize={item.squareSize}
                textWidth={item.textWidth}
                marginBottom={item.marginBottom}
                marginTop={item.marginTop}
              />
            </div>
          )
        )}
      </Dropdown.Item>
    );
  };

  SkeletonItem.propTypes = {
    squareSize: PropTypes.string.isRequired, 
    textWidth: PropTypes.string.isRequired, 
    marginBottom: PropTypes.number, 
    marginTop: PropTypes.number, 
  };